import React, { useEffect, useRef, useState } from "react";
import { AlertTriangle, XOctagon } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { AiTextButton } from "@/components/AiTextButton";

const FIELDS = [["diagnosis", "diagnosis", "mechanicDiagnosisPh"], ["work_done", "workPerformed", "mechanicWorkPh"], ["notes", "mechanicAdvice", "mechanicAdvicePh"]];

export const MechanicNotes = ({ card, t, locked, onSave }) => {
  const [v, setV] = useState({ diagnosis: card.diagnosis || "", work_done: card.work_done || "", notes: card.notes || "" });
  const timer = useRef(null);
  const dirty = useRef(false);
  useEffect(() => { if (!dirty.current) setV({ diagnosis: card.diagnosis || "", work_done: card.work_done || "", notes: card.notes || "" }); }, [card.diagnosis, card.work_done, card.notes]);
  const change = (k, val) => {
    const next = { ...v, [k]: val }; setV(next); dirty.current = true;
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => { await onSave(next); dirty.current = false; }, 900);
  };
  const advice = card.inspection_advice || [];
  return (
    <section className="rounded-2xl border border-border bg-card p-4 sm:p-5 space-y-3" data-testid="mechanic-step-findings">
      <h2 className="font-semibold text-base md:text-lg flex items-center gap-2"><span className="h-8 w-8 rounded-full bg-primary text-primary-foreground grid place-items-center font-mono font-bold text-sm">6</span>{t("mech_notes_title")}</h2>
      <div className="rounded-xl border border-border bg-muted/30 p-3" data-testid="mechanic-advice-auto">
        <div className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground mb-2">{t("mech_advice_title")}</div>
        {advice.length === 0 ? <p className="text-sm text-muted-foreground">{t("mech_advice_empty")}</p> : (
          <ul className="space-y-1">
            {advice.map((a) => (
              <li key={a.key} className="flex items-center gap-2 text-sm">
                {a.status === "replace" ? <XOctagon className="h-4 w-4 text-rose-500 shrink-0" /> : <AlertTriangle className="h-4 w-4 text-amber-500 shrink-0" />}
                <span className="font-medium">{a.label}</span>
                <span className="text-muted-foreground">— {t(`mech_${a.status}`)}{a.note ? ` · ${a.note}` : ""}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
      {FIELDS.map(([k, lbl, ph]) => (
        <div key={k}>
          <label className="block text-xs font-medium text-muted-foreground mb-1 flex items-center justify-between">{t(lbl)}<AiTextButton value={v[k]} onApply={(val) => change(k, val)} field={k === "notes" ? "advice" : k} context={{ vehicle: [card?.car_make, card?.car_model].filter(Boolean).join(" "), plate: card?.car_plate }} disabled={locked} testId={`ai-mech-${k}`} /></label>
          <Textarea rows={2} value={v[k]} onChange={(e) => change(k, e.target.value)} disabled={locked} placeholder={t(ph)} className="text-base" data-testid={`mechanic-${k === "work_done" ? "workdone" : k === "notes" ? "advice" : k}`} />
        </div>
      ))}
    </section>
  );
};
